import * as React from 'react';
import { Button, Input, Modal } from 'antd';
import { ModalProps } from 'antd/es/modal';
import styled from 'styled-components';
import { ReactNode, useEffect, useLayoutEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'theme';
import { InputProps } from 'antd/es/input';
import ModalBase from 'components/common/ModalBase';

function AutoSelectingInput(props: InputProps) {
    const inputRef = useRef(null);

    useEffect(() => {
        // @ts-ignore
        inputRef.current.select();
    }, []);

    return <Input ref={inputRef} {...props} />;
}

export default AutoSelectingInput;
